import { render, staticRenderFns } from "./FlowChangeProperties.vue?vue&type=template&id=c9e2d334&"
import script from "./FlowChangeProperties.vue?vue&type=script&lang=ts&"
export * from "./FlowChangeProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports